import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { useLenis } from "@/hooks/useLenis";

export const Layout = ({ children }) => {
  useLenis();
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="min-h-screen bg-offwhite grain">
      <Header />
      <main className="pt-20">{children}</main>
      <Footer />
    </div>
  );
};
